import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { RouteModel } from '../../models/route.model';
import { AppService } from '../../services/app.service';
import { LocationComponent } from '../location/location.component';
import { PoiComponent } from '../poi/poi.component';
import { StaticPageComponent } from '../static-page/static-page.component';
import { PropertyTypeComponent } from '../property-type/property-type.component';
import { RoutingService } from '../../services/routing.service';
import { PropertyComponent } from '../property/property.component';

@Component({
  selector: 'app-routing',
  templateUrl: './routing.component.html',
  styleUrls: ['./routing.component.scss'],
  imports: [
    LocationComponent,
    PoiComponent,
    StaticPageComponent,
    PropertyTypeComponent,
    PropertyComponent,
  ],
  standalone: true,
})
export class RoutingComponent implements OnInit {
  data: RouteModel = new RouteModel();
  initialLoad = true;

  constructor(
    private appService: AppService,
    private router: Router,
    private routingService: RoutingService,
  ) {
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e) => {
        this.getData();
      });
  }

  ngOnInit(): void {
    if (this.initialLoad) this.getData();
  }

  getData() {
    if (this.router.url.includes('.css')) return;
    const route = this.router.url.split('?')[0];

    if (route == '/favicon.ico') return;
    if (route == '/robots.txt') return;
    if (route == '/sitemap.xml') return;

    this.initialLoad = false;
    if (route && route != '/') {
      this.appService
        .getData(`route?url=${this.router.url.split('?')[0]}`)
        .then((x) => {
          this.data = JSON.parse(x);
          this.routingService.route.set(this.data);
          this.getRedirectUrl();
        });
    }
  }

  getRedirectUrl() {
    if (this.data) {
      if (this.data.RedirectTo) this.router.navigateByUrl(this.data.RedirectTo);

      if (this.data.Type == 0) this.router.navigateByUrl('/');
    }
  }
}
